import React from 'react'
import { withRouter } from './../lib/router'
import ModalController from './modal/modalcontroller'
import Header from './header'
import Stats from './stats'
import Completed from './completed'
import Cancelled from './cancelled'
import Failed from './failed'
import Validation from './validation'
import StatsFooter from './statsfooter'
import Footer from './footer'
import { STATUS, HOSTS, getLoader } from './../lib/helper'
import _ from 'underscore'
import { connect } from 'react-redux'
import * as actionCreators from '../actionCreators'
import { bindActionCreators } from 'redux'
import PropTypes from 'prop-types'
import ImmutablePropTypes from 'react-immutable-proptypes'

class App extends React.Component {
	constructor(props) {
		super(props)
		this.state = {}
		this.refresh = this.refresh.bind(this)
		this.getMigrate = this.getMigrate.bind(this)
		this.isMigrateAvailable = this.isMigrateAvailable.bind(this)
		this.cancel = this.cancel.bind(this)
		this.content = this.content.bind(this)
	}
	getMigrate() {
		const { task } = this.props
		return task.get('migrate') && task.get('migrate').first()
	}
	isMigrateAvailable() {
		let migrate = this.getMigrate()
		return (migrate && migrate.get('gid'))
	}
	cancel() {
		const { actions, match } = this.props
		let migrate = this.getMigrate()
		actions.openModal({ name: "CancelModal", gid: match.params.gid, migrate: migrate })
	}
	canUpsell() {
		let migrate = this.getMigrate()
		return migrate.get('origin') === ORIGIN.MIGRATEGURU &&
				!_.contains([HOSTS.FLYWHEEL, HOSTS.DREAMHOST], migrate.get('destination_host'))
	}
	content() {
		const { actions, task, match, history, bvKeyMigrationEnabled, httpMigrationEnabled, cwsAutoscaleEnabled, showAutomatticHost } = this.props
		let migrate = this.getMigrate()
		switch (migrate.get('migration_complete')) {
		case STATUS.RUNNING:
			return <span>
				<Stats task={task} canUpsell={this.canUpsell()} cancel={this.cancel}/>
				<StatsFooter cancel={this.cancel} migrate={migrate}/>
			</span>
		case STATUS.COMPLETED: 
			return <Completed task={task} migrate={migrate} canUpsell={this.canUpsell()} actions={actions} match={match}/>
		case STATUS.CANCELLED: return <Cancelled migrate={migrate} history={history}/>
		case STATUS.FAILED: return <Failed migrate={migrate} history={history}/>
		case STATUS.INITIALIZING:
		case STATUS.VALIDATING:
		case STATUS.VALFAILED: return <Validation
			migrate={migrate}
			actions={actions}
			params={match.params}
			history={history}
			bvKeyMigrationEnabled={bvKeyMigrationEnabled}
			httpMigrationEnabled={httpMigrationEnabled}
			cwsAutoscaleEnabled={cwsAutoscaleEnabled}
			showAutomatticHost={showAutomatticHost}
		/>
		default: return null
		}
	}
	componentDidUpdate(prevProps) {
		this.refresh_params = _.extend(this.refresh_params, {
			last_refreshed_at: prevProps.last_refreshed_at
		})
	}
	componentDidMount() {
		const { match } = this.props
		let gid = match.params.gid
		this.refresh_params = { key: gid }
		this.refresh()
		this.timeout = setInterval(this.refresh, 20000)
	}
	componentWillUnmount() {
		if (this.timeout) clearInterval(this.timeout)
	}
	refresh() {
		const { actions } = this.props
		actions.dataFetch(this.refresh_params)
	}
	render() {
		const { task } = this.props
		if (task.size === 0) {
			return getLoader()
		}
		let migrate = this.getMigrate()
		return <span>
			<ModalController key="modals" {...this.props} />
			<Header migrate={migrate} />
			{ this.content() }
			<Footer migrate={migrate}/>
		</span>
	}
}

App.propTypes = {
	task: ImmutablePropTypes.map,
	bvKeyMigrationEnabled: PropTypes.bool,
	httpMigrationEnabled: PropTypes.bool,
	actions: PropTypes.object,
	match: PropTypes.object,
	last_refreshed_at: PropTypes.number
}

const AppWithRouter = withRouter(App)

const mapStateToProps = (state) => {
	let stateObj = {}
	state.forEach((value, key) => {
		stateObj[key] = value
	})
	return stateObj
}

function mapDispatchToProps(dispatch) {
	return { actions: bindActionCreators(actionCreators, dispatch) }
}

const mergeProps = (stateProps, dispatchProps, ownProps) => {
	return Object.assign({}, ownProps, stateProps, dispatchProps)
}

const AppContainer = connect(
	mapStateToProps,
	mapDispatchToProps,
	mergeProps
)(AppWithRouter)

export default AppContainer
